import { RouteRecordRaw } from 'vue-router';
// import NoHeaderLayout from '@/components/layout/NoHeaderLayout.vue';
import CRMLayout from '@/components/tailwind/layout/crm/CRMLayout.vue';

const crmRoutes: Array<RouteRecordRaw> = [
  {
    path: '/crm',
    name: 'CRMDashboardPage',
    meta: {
      label: 'CRMDashboardPage',
      layout: CRMLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/crm/CRMDashboardView.vue'),
  },
];

export default crmRoutes;
